<template>
  <div class="docs">
    <div class="docs_area">
      <h1>Documents</h1>

      <a-divider></a-divider>

      <div v-if="!loading">
        <div v-for="doc in docs" class="item" :key="doc.id">
          <a :href="doc.download_link" target="_self">{{ doc.file_name }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "docs",
  data() {
    return {
      loading: false,
      docs: [],
    };
  },
  created() {
    this.loading = true;
    this.$axios
      .get(
        `/data/docs/${this.$route.params.from}/${this.$route.params.internal_number}`
      )
      .then((r) => {
        if (r.status === 200) {
          this.docs = r.data;
        }
      })
      .catch((_) => {})
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
<style media="screen">
.docs_area {
  padding: 80px 20px 0 100px;
}
</style>
